import React, { useEffect, useState } from "react";
import useApi from "./useApi";

import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import "./User.css";
import { Autocomplete, TextField } from "@mui/material";
import ic_clone from "./ic_clone.png";
import { data } from "react-router-dom";
import axios from "axios";
import { base_url } from "../../utils/AxiosConfig";

function CloneUser(props) {

  const { setShowClonePopup, clickedUserFromList } = props;

  const [
    selectedEmployeeObjectFromAutoComplete,
    setSelectedEmployeeObjectFromAutoComplete,
  ] = useState(null);
  const [
    selectedEmployeeObjectFromAutoCompleteTo,
    setSelectedEmployeeObjectFromAutoCompleteTo,
  ] = useState(null);

    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(true);

  const {
    data: getData,
    loading: getLoading,
    error: getError,
    get: getUsers,
  } = useApi();
  const {
    data: dataPostClone,
    loading: loadingPostClone,
    error: errorPostClone,
    post: postClone,
  } = useApi();

  useEffect(() => {
    if (clickedUserFromList) {
      setSelectedEmployeeObjectFromAutoComplete(clickedUserFromList);
    }
  }, [clickedUserFromList]);

  useEffect(() => {
    // getUsers(
    //   `https://cubixweberp.com:213/api/CpaysCount/${COMPANY_CODE}/USERLIST/-/-`,
    // );
  fetchUsers();
  }, []);

  const userDataArrayFromLocal = JSON.parse(
    localStorage.getItem("BondTimeuserDataArray") || "-",
  );
  const COMPANY_CODE = userDataArrayFromLocal?.[0]?.cmpcode;

  console.log("COMPANY_CODE:", COMPANY_CODE);


    const fetchUsers = async () => {
      try {
        setLoading(true);
  
        const response = await axios.get(
          `${base_url}/api/CpaysCount/${COMPANY_CODE}/USERLIST/-/-`,
        );
  
        console.log("User List:", response.data);
  
        setUsers(response.data || []);
      } catch (error) {
        console.error("Error fetching users:", error);
      } finally {
        setLoading(false);
      }
    };
  


  const cloneUser = () => {
    let arraytoPass = [
      {
        CmpCode: COMPANY_CODE,
        mode: "CLONE",
        user1: selectedEmployeeObjectFromAutoComplete.loginame,
        user2: selectedEmployeeObjectFromAutoCompleteTo.loginame,
        task_creator_id: "ADMIN",
        useraccess: "-",
      },
    ];

    let serialize = JSON.stringify(arraytoPass);

    console.log("arraytoPass>>. ", arraytoPass);

    postClone(`https://cubixweberp.com:213/api/CRMUserRights`, serialize, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  };

  useEffect(() => {
    if (dataPostClone) {
      if (dataPostClone?.result?.trim()?.toUpperCase() === "SAVED") {
        alert("Successfully Cloned User");
        setSelectedEmployeeObjectFromAutoComplete(null);
        setSelectedEmployeeObjectFromAutoCompleteTo(null);
      }
    }
  }, [dataPostClone]);

  return (
    <div className="bg-white p-4 rounded">
      <h4 className="flex items-center text-xl text-blue-500">
        {" "}
        <img className="w-10 me-2" src={ic_clone} /> Clone User
      </h4>

      <div className="flex mt-4 items-center">
        <Autocomplete
          sx={{ width: "300px" }}
          options={Array.isArray(users) ? users : []}
          value={selectedEmployeeObjectFromAutoComplete}
          getOptionLabel={(option) => (option.loginame ? option.loginame : "")}
          onChange={(event, newValue) => {
            console.log("selected employee", newValue);
            setSelectedEmployeeObjectFromAutoComplete(newValue);
          }}
          renderInput={(params) => (
            <TextField {...params} label="Select User" variant="outlined" />
          )}
          filterOptions={(options, { inputValue }) =>
            options.filter(
              (option) =>
                option.empcode
                  .toLowerCase()
                  .includes(inputValue.toLowerCase()) ||
                option.loginame
                  .toLowerCase()
                  .includes(inputValue.toLowerCase()),
            )
          }
        />

        <svg
          className="ms-3"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          width="24"
          height="24"
          viewBox="0 0 24 24"
        >
          <path d="M5 12h14M13 5l7 7-7 7" />
        </svg>

        <Autocomplete
          className="ms-4"
          sx={{ width: "300px" }}
          // options={getData}
          options={Array.isArray(users) ? users : []}
          value={selectedEmployeeObjectFromAutoCompleteTo}
          getOptionLabel={(option) => (option.loginame ? option.loginame : "")}
          onChange={(event, newValue) => {
            console.log("selected employee", newValue);
            setSelectedEmployeeObjectFromAutoCompleteTo(newValue);
          }}
          renderInput={(params) => (
            <TextField {...params} label="Select User" variant="outlined" />
          )}
          filterOptions={(options = [], { inputValue }) =>
            options.filter(
              (option) =>
                option?.empcode
                  ?.toLowerCase()
                  ?.includes(inputValue.toLowerCase()) ||
                option?.loginame
                  ?.toLowerCase()
                  ?.includes(inputValue.toLowerCase()),
            )
          }
        />
      </div>

      <div className="flex justify-end">
        <button
          className="mt-4 bg-gray-100 text-gray-800 px-4 py-2 rounded hover:bg-gray-700 hover:text-gray-100 disabled:opacity-50"
          onClick={() => setShowClonePopup((prev) => !prev)}
        >
          Cancel
        </button>
        <button
          className="ms-4 mt-4 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
          onClick={() => cloneUser()}
        >
          Clone
        </button>
      </div>
    </div>
  );
}

export default CloneUser;
